<template lang="pug">
    div.controls

        // Stop Streaming Link button
        v-tooltip(
            color="black"
            top
            v-if="type === 'live' && (isAdmin || isInstructor) && channel && channel.inputs"
        )
            template(v-slot:activator="{ on }")
                v-btn.button.mr-0.ml-0(
                    color="white"
                    v-on="on"
                    flat
                    :disabled="type !== 'live' || disableStopSession"
                    :loading="disableStopSession"
                    icon
                    @click="stop"
                )
                    v-icon.icon stop
            span(v-html="$t('sessions.list.stopStreamingHint')")

        // Copy Streaming Link button
        v-tooltip(
            color="black"
            top
            v-if="(type === 'planned' || type === 'live') && (isAdmin || isInstructor) && channel && channel.inputs"
        )
            template(v-slot:activator="{ on }")
                v-btn.button.mr-0(
                    color="white"
                    v-on="on"
                    flat
                    icon
                    @click="copyLink"
                )
                    v-icon.icon link
            span(v-html="$t('sessions.list.copyStreamingLinkHint')")

        // Edit Meditation button
        v-tooltip(
            v-if="isAdmin"
            color="black"
            top
        )
            template(v-slot:activator="{ on }")
                v-btn.button.mr-0(
                    class="button"
                    color="white"
                    v-on="on"
                    flat
                    icon
                    @click="edit"
                )
                    v-icon.icon edit
            span(v-html="$t('sessions.list.editHint')" v-if="isInstructor")
            span(v-html="$t('general.edit')" v-if="isAdmin")
</template>

<script>
    import VueTypes from 'vue-types';
    import dayjs from 'dayjs';
    import Handler from '~services/Handler';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        props: {
            item: VueTypes.object.def({}),
            type: VueTypes.string.def(''),
            sessionId: VueTypes.string.def(''),
            startedAt: VueTypes.date,
            channel: VueTypes.object.def({})
        },
        data() {
            return {
                disableStopSession: false
            };
        },
        computed: {
            ...mapGetters('auth', ['isAdmin', 'isInstructor'])
        },
        methods: {
            ...mapActions('sessions', ['stopSession']),
            /**
             * Copy link into buffer
             */
            copyLink: function() {
                let successMessage = this.$t('sessions.list.successMessage');
                let errorMessage = this.$t('sessions.list.errorMessage');
                let dummy = document.createElement('input');

                document.body.appendChild(dummy);

                if (
                    this.channel &&
                    this.channel.inputs &&
                    this.channel.inputs.length &&
                    this.channel.inputs[0] &&
                    this.channel.inputs[0].url
                ) {
                    dummy.value = this.channel.inputs[0].url;
                    dummy.select();
                    document.execCommand('copy');

                    Handler.handleResponse(
                        { ok: true },
                        successMessage,
                        errorMessage,
                        undefined
                    );
                }

                document.body.removeChild(dummy);
            },

            /**
             * Stop Meditation and Update Meditation type
             */
            async stop() {
                this.disableStopSession = true;

                // API request to Stop Meditation
                const resp = await this.stopSession(this.sessionId);

                // Update type
                if (resp) {
                    this.type = 'recorded';
                }

                this.disableStopSession = false;
            },

            /**
             * Edit Meditation
             */
            edit() {
                let currentDate = dayjs();
                let startedAt = dayjs(this.startedAt);
                let diffTime = startedAt.diff(currentDate, 'seconds');

                if (
                    this.isAdmin ||
                    (this.isInstructor && diffTime > 0 && diffTime <= 10 * 60)
                ) {
                    if (this.startedAt) {
                        return this.$router.push({
                            name: 'dashboard.sessions.edit',
                            params: { id: this.sessionId }
                        });
                    }

                    return this.$router.push({
                        name: 'dashboard.sessions.editRecorded',
                        params: { id: this.sessionId }
                    });
                }
            }
        }
    };
</script>
